import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const purchases = [{
  name: 'María',
  province: 'Buenos Aires'
}, {
  name: 'Carolina',
  province: 'Córdoba'
}, {
  name: 'Luciana',
  province: 'Santa Fe'
}, {
  name: 'Valentina',
  province: 'Mendoza'
}, {
  name: 'Julieta',
  province: 'Tucumán'
}, {
  name: 'Florencia',
  province: 'Entre Ríos'
}, {
  name: 'Camila',
  province: 'Salta'
}, {
  name: 'Paula',
  province: 'Neuquén'
}, {
  name: 'Agustina',
  province: 'Misiones'
}, {
  name: 'Rocío',
  province: 'San Juan'
}, {
  name: 'Daniela',
  province: 'Chaco'
}, {
  name: 'Sofía',
  province: 'Río Negro'
}, {
  name: 'Milagros',
  province: 'La Pampa'
}, {
  name: 'Belén',
  province: 'Jujuy'
}, {
  name: 'Antonella',
  province: 'Corrientes'
}];
const packs = ['Pack Mamá', 'Colección Familiar'];
export function StickyBottomBar() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showNotification, setShowNotification] = useState(false);
  const [currentPack, setCurrentPack] = useState(packs[0]);
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 800);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    const showNext = () => {
      setCurrentPack(packs[Math.floor(Math.random() * packs.length)]);
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
        setTimeout(() => {
          setCurrentIndex(prev => (prev + 1) % purchases.length);
        }, 500);
      }, 4000);
    };
    const initialDelay = setTimeout(showNext, 2000);
    const interval = setInterval(showNext, 15000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  const current = purchases[currentIndex];
  const minutesAgo = Math.floor(Math.random() * 12) + 1;
  return <AnimatePresence data-id="element-198">
      {isVisible && showNotification && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-lg border border-gray-200 px-3 py-2 max-w-[280px]" data-id="element-199">
          <div className="flex items-center gap-2" data-id="element-200">
            <span className="text-lg" data-id="element-201">🛒</span>
            <div data-id="element-202">
              <p className="text-xs font-semibold text-[#1A1A1A] leading-tight" data-id="element-203">
                {current.name} de {current.province}
              </p>
              <p className="text-[10px] text-[#F5A623] font-semibold leading-tight mt-0.5" data-id="element-204">
                compró {currentPack}
              </p>
              <p className="text-[10px] text-gray-500 leading-tight" data-id="element-205">
                hace {minutesAgo} min
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}